import * as _ from 'lodash'
import { sanitizeHtmlString } from '@app/composables/useSanitizedHtml'

/**
 * Convierte un mensaje con variables {{variable}} y saltos de línea en HTML
 * sanitizado, resaltando cada variable con un span[data-mention-id].
 * @param {string} msg - Mensaje con variables {{}} y saltos de línea.
 * @returns {string} - HTML sanitizado listo para v-html.
 */
export function messageToHTML(msg) {
  if (!msg || typeof msg !== 'string') return ''

  let formattedMsg = msg

  const variablesRegex = /{{[^{}]+}}/g
  const matches = msg.match(variablesRegex)
  if (!_.isEmpty(matches)) {
    const foundVariables = _.uniq(matches.map(v => v.replace(/[{}]/gi, '')))
    // Reemplazar texto rodeado en {{}} por HTML con estilo de etiqueta
    for (const v of foundVariables) {
      formattedMsg = formattedMsg
        .replaceAll(`{{${v}}}`, `<span data-mention-id="${v}"><b>[${v.replace(/_/gi, ' ')}]</b></span>`)
    }
  }
  // Reemplazar saltos de líneas por tags de párrafo
  formattedMsg = `<p>${formattedMsg.replace(/\n/g, '</p><p>')}</p>`

  return sanitizeHtmlString(formattedMsg)
}
